(function () {
  const roots = document.querySelectorAll('[data-lite-product-reviews]');
  if (!roots.length) return;

  function stars(rating) {
    const rounded = Math.round(Number(rating) || 0);

    return Array.from({ length: 5 }, function (_, index) {
      return index < rounded ? '★' : '☆';
    }).join('');
  }

  function textValue(value) {
    if (value === undefined || value === null || value === '') return '';

    if (typeof value === 'string' || typeof value === 'number') {
      return String(value);
    }

    if (typeof value === 'object') {
      const keys = [
        'name',
        'display_name',
        'reviewer_name',
        'customer_name',
        'user_name',
        'first_name',
        'full_name',
      ];

      for (const key of keys) {
        if (value[key]) return textValue(value[key]);
      }

      if (value.first_name || value.last_name) {
        return [value.first_name, value.last_name].filter(Boolean).join(' ');
      }
    }

    return '';
  }

  function firstValue(item, paths) {
    for (const path of paths) {
      const parts = path.split('.');
      let value = item;

      for (const part of parts) {
        value = value && value[part];
      }

      const text = textValue(value);
      if (text) return text;
    }

    return '';
  }

  function normaliseReviews(payload) {
    const possibleLists = [
      payload && payload.reviews,
      payload && payload.data,
      payload && payload.results,
      payload && payload.response && payload.response.reviews,
      payload && payload.data && payload.data.reviews,
    ];

    return possibleLists.find(Array.isArray) || [];
  }

  function formatDate(value) {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return textValue(value);

    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  function isVerified(review) {
    return Boolean(
      review.verified ||
        review.verified_buyer ||
        review.verified_customer ||
        review.reviewer_verified ||
        (review.reviewer && review.reviewer.verified)
    );
  }

  function appendText(parent, className, text) {
    if (!text) return;

    const element = document.createElement('span');
    element.className = className;
    element.textContent = text;
    parent.appendChild(element);
  }

  function renderReviews(root, reviews) {
    const list = root.querySelector('[data-review-list]');
    if (!list) return;

    list.innerHTML = '';

    const visibleReviews = reviews.filter(function (review) {
      return firstValue(review, ['review', 'body', 'comments', 'comment', 'text', 'content']);
    });

    if (!visibleReviews.length) {
      const empty = document.createElement('p');
      empty.className = 'lite-product-reviews__muted';
      empty.textContent = 'No reviews have been added for this product yet.';
      list.appendChild(empty);
      return;
    }

    visibleReviews.forEach(function (review) {
      const rating = firstValue(review, ['rating', 'score', 'star_rating']);
      const body = firstValue(review, ['review', 'body', 'comments', 'comment', 'text', 'content']);
      const name =
        firstValue(review, [
          'reviewer.name',
          'reviewer.display_name',
          'reviewer',
          'customer.name',
          'customer.display_name',
          'author.name',
          'name',
          'reviewer_name',
          'customer_name',
          'user_name',
        ]) || 'Anonymous';
      const title = firstValue(review, [
        'title',
        'review_title',
        'product.name',
        'product_title',
        'product_name',
      ]);
      const date = formatDate(
        firstValue(review, ['date_created', 'created_at', 'date', 'review_date', 'timeago'])
      );

      const article = document.createElement('article');
      article.className = 'lite-product-review';

      const meta = document.createElement('div');
      meta.className = 'lite-product-review__meta';

      appendText(meta, 'lite-product-review__stars', stars(rating));
      appendText(meta, 'lite-product-review__name', name);

      if (isVerified(review)) {
        appendText(meta, 'lite-product-review__verified', 'Verified Customer');
      }

      appendText(meta, 'lite-product-review__date', date);
      article.appendChild(meta);

      if (title) {
        const titleElement = document.createElement('h3');
        titleElement.className = 'lite-product-review__title';
        titleElement.textContent = title;
        article.appendChild(titleElement);
      }

      const text = document.createElement('p');
      text.className = 'lite-product-review__body';
      text.textContent = body;
      article.appendChild(text);

      list.appendChild(article);
    });
  }

  function loadReviews(root) {
    if (root.dataset.loaded === 'true') return;
    root.dataset.loaded = 'true';

    const params = new URLSearchParams({
      store: root.dataset.store,
      sku: root.dataset.sku,
      type: 'product_review',
      page: '1',
      per_page: root.dataset.limit || '6',
      must_have_body: 'true',
      sort: 'date_desc',
    });

    fetch('https://api.reviews.io/reviews?' + params.toString(), {
      credentials: 'omit',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Reviews request failed');
        return response.json();
      })
      .then(function (payload) {
        renderReviews(root, normaliseReviews(payload));
      })
      .catch(function () {
        const list = root.querySelector('[data-review-list]');
        if (list) {
          list.innerHTML =
            '<p class="lite-product-reviews__muted">Reviews are currently unavailable.</p>';
        }
      });
  }

  roots.forEach(function (root) {
    const score = root.querySelector('[data-review-score]');
    if (score) {
      const number = Number(score.textContent);
      if (!Number.isNaN(number)) score.textContent = number.toFixed(2);
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          if (
            entries.some(function (entry) {
              return entry.isIntersecting;
            })
          ) {
            observer.disconnect();
            loadReviews(root);
          }
        },
        { rootMargin: '250px 0px' }
      );

      observer.observe(root);
    } else {
      loadReviews(root);
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest('button, a, summary, [role="tab"]');
      if (!trigger || !/review/i.test(trigger.textContent || '')) return;

      window.setTimeout(function () {
        roots.forEach(loadReviews);
      }, 0);
    },
    true
  );
})();
